import axios from 'axios'

import config from '../../config'

const createWorkOrderReminder = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/Reminders/WorkOrder`
  return axios.post(url, data)
}

export default createWorkOrderReminder
